import { liveQuery } from 'dexie';
import { getDB  } from './db.dexie';
import { from } from 'rxjs';

// ➕ add
export async function addCustomer(data: any) {
  const db = getDB();
  return db.customers.add({
    ...data,
    updatedAt: Date.now(),
    isSynced: false
  });
}

// ➕ add
export async function insertCustomer(_id:string, data: any) {
  const db = getDB();
  return db.customers.put({
    _id,
    ...data,
    updatedAt: Date.now(),
    isSynced: false
  });
}

// ➕ bulk add
export async function addCustomers(list: any[]) {
  const db = getDB();
  return db.transaction('rw', db.customers, async () => {
    await db.customers.bulkAdd(
      list.map(item => ({
        ...item,
        updatedAt: Date.now(),
        isSynced: false
      }))
    );
  });
}

// ✏️ update
export async function updateCustomer(_id: string, data: any) {
  const db = getDB();
  return db.customers.update(_id, {
    ...data,
    updatedAt: Date.now(),
    isSynced: false
  });
}

// ❌ soft delete
export async function deleteCustomer(id: string) {
  const db = getDB();
  return db.products.update(id, {
    isDeleted: true,
    updatedAt: Date.now(),
    isSynced: false
  });
}

// ❌ Hard delete
export async function hardDeleteProduct(_id: string) {
  const db = getDB();
  return db.customers.delete(_id);
}


// 🔍 get all
export async function getAllCustomers() {
  const db = getDB();
  return db.customers.toArray();
}

// 🔍 get liveall
export function getLiveAllCustomers() {
  const db = getDB();
  return from(liveQuery(() => db.customers.toArray()));
}

// 🔍 get by id
export async function getCustomerById(_id: string) {
  const db = getDB();
  return db.customers.get(_id);
}
